// React-Screen CInventoryPanel - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026 (Nutzer-Vorgabe: keine Huellen mehr, verbindlich
// sind Pixelgleichheit und 100% Funktionalitaet). React rendert die
// Knoepfe jetzt selbst ueber den gemeinsamen Baustein SecondaryPanel;
// der Legacy-Widget-Baum aus LYT_secondaryPanel.xml kommt nicht mehr vor.
// Die HANDLER sind weiter ueber spec.legacyMethods WOERTLICH uebernommen
// (Bridge-Vertrag 8) - `this`/`me` ist die Bridge.
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';

const legacy = {};


legacy.setMain = function(main) {
    this.Main = main;
}

legacy.setCallback = function() {
    POS.events.setOnClickEventCallback(this, this.disappear, true);
}

legacy.disappear = function(me) {
    me.Main.lastSubmenuId = "INV";
    window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
   /* me.properties.styles.visibility = "hidden";
    me.reStyle();*/
	document.getElementById(me.id).style.visibility="hidden";
}

legacy.orderings = function(component, parameters) {
return;
    log.add(4, "Login", "Entering Orderings mode");

    var tablediv = $('#orderings');
    if (!tablediv.length) {
        var text = POS.lang.getText("MESSAGES", "PLEASE_WAIT");
        POS.hourGlass.show(text);
        var me = POS.getComponentById(parameters[0]);
        //var CInventoryPanelClass = this;

        var maindiv = $('#' + me.Main.id);

        var sq3 = require('sqlite3');
        var reportsdb = new sq3.Database("var/db/POSysseus_Reports.db"); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
        var tablename = "PRODSELLINGS";

        /*
                var now = new Date();
                var year = now.getFullYear();
                var month = ("0" + (now.getMonth() + 1)).substr(-2);
                var day = ("0" + now.getDate()).substr(-2);
                var thisday = year + "-" + month + "-" + day;

                var oneweekbefore = new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000);
                year = oneweekbefore.getFullYear();
                month = ("0" + (oneweekbefore.getMonth() + 1)).substr(-2);
                day = ("0" + oneweekbefore.getDate()).substr(-2);
                var previousday = year + "-" + month + "-" + day;

                var fourweeksbefore = new Date(now.getTime() - 4 * 8 * 24 * 60 * 60 * 1000);
                year = fourweeksbefore.getFullYear();
                month = ("0" + (fourweeksbefore.getMonth() + 1)).substr(-2);
                day = ("0" + fourweeksbefore.getDate()).substr(-2);
                var previousmonth = year + "-" + month + "-" + day;
        */
        var now = new Date();
        var thisday = DateToString(now);
        var previousday = DateToString(new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000)); //one week before
        var previousmonth = DateToString(new Date(now.getTime() - 4 * 8 * 24 * 60 * 60 * 1000));

        var prodarray = new Array();
        var sql = "SELECT PRODNAME,sum(Sold)/4 as pcsmonth,sum(case when DAY>='" + previousday + "' then Sold else 0 end) as pcsweek FROM PRODSELLINGS where DAY>='" + previousmonth + "' and DAY<='" + thisday + "' and Type='SLD' group by PRODNAME order by pcsmonth desc";
        //    var sql = "SELECT PRODNAME,sum(Sold) as pcs FROM PRODSELLINGS where DAY>='" + previousday + "' and DAY<='" + thisday + "' and Type='SLD' group by PRODNAME order by pcs desc";
        reportsdb.all(sql, function(err, rows) {
            for (var i = 0; i < rows.length; i++) {
                var prod = {
                    name: rows[i].ProdName,
                    week: rows[i].pcsweek,
                    month: rows[i].pcsmonth,
                    year: 0
                }
                prodarray.push(prod);
            }
            reportsdb.close();

            sql = "SELECT Text1 from PROD group by Text1 order by Text1;";
            $.when(POS.SQLiteCon.execute(sql)).then(function(rows1) {
                for (var i = 0; i < rows1.length; i++) {
                    var prod = {
                        name: rows1[i].Text1,
                        week: 0,
                        month: 0,
                        year: 0
                    }
                    prodarray.push(prod);
                }

                var table = me.createOrderingTable(prodarray);
                POS.hourGlass.hide();


                tablediv = $('<div id=orderings>');
                tablediv.append(table);
                tablediv.css("width", "100%");
                tablediv.css("height", "97.5%");
                tablediv.css("background-color", "white");
                tablediv.css("z-index", "200000");
                tablediv.css("position", "absolute");
                maindiv.append(tablediv);
                var numpad = $("div[name='CPushPanel:0:2:4:0']");
                numpad = numpad.clone();
                tablediv.append(numpad);
                numpad.css("position", "absolute");
                numpad.css("left", "72%");
                numpad.css("top", "5%");
                numpad.css("width", "20%");
                numpad.css("height", "30%");
                var click = function(event) {
                    var number = event.target.firstChild.data;
                    //var img = $('#'+event.target.id).css('backgroud-image');
                    //var img =  event.target.style.backgroundImage;
                    if (number && number != undefined) {
                        //var focused = $(':focus');
                        var focused = me.focusedComponent;
                        if (focused) {
                            var val = focused.val();
                            val = val + '' + number;
                            focused.val(val);
                        }
                    } else if (event.target.style.backgroundImage.indexOf('X') > 0) {
                        var focused = me.focusedComponent;
                        if (focused) {
                            focused.val('');
                        }

                    } else if (event.target.style.backgroundImage.indexOf('OK') > 0) {
                        var focused = me.focusedComponent;
                        if (focused) {
                            focused.css('background-color', 'white');
                            me.focusedComponent = null;
                        }
                    }
                }
                var divs = numpad.find('div');
                divs.on('mousedown', null);
                divs.on('mouseup', null);
                divs.on('mouseout', null);
                divs.on('click', click);

                var okbut = $('<button>');
                tablediv.append(okbut);
                okbut.css({
                    "position": "absolute",
                    "left": "72vw",
                    "top": "35vh",
                    "width": "20%",
                    "height": "8%",
                    "background-color": "rgb(173, 228, 174)"
                });
                var p = $('<p style="font-size:2vh;">Abschicken</p>');

                okbut.append(p);
                okbut.click(
                    function(event) {
                        tablediv.remove();
                        //Daten senden!!!!!
                    });

                var savebut = okbut.clone();
                savebut.css({
                    "top": "45vh",
                    "background-color": "rgb(255,165,0)"
                });
                savebut.find('p').text('Speichern');
                tablediv.append(savebut);
                savebut.click(
                    function(event) {
                        tablediv.hide();
                    });

                var cancelbut = okbut.clone();
                cancelbut.css({
                    "top": "55vh",
                    "background-color": "rgb(228, 173, 173)"
                });
                cancelbut.find('p').text('Zurück');
                cancelbut.click(
                    function(event) {
                        tablediv.remove();
                    });

                tablediv.append(cancelbut);
                //rgb(228, 173, 173)


                var focused = '#' + prodarray[0].name.replace(/ /g, '_');
                $(focused).trigger("click");

            });

        });

    } else {
        tablediv.show();
    }
    //select * from PROD group by Text1;

}


legacy.createOrderingTable = function(prodarray) {

    var me = this;
    var tablediv = $('<div>');
    var header = ["Bild", "Bezeichnung", "Monats-&#8709;<br/>Menge pro Woche", "Wochen-&#8709;<br/>Menge letzte Woche", "", "Bestellmenge"];
    var fields = ["", "name", "month", "week", "year", "amount"];
    var fieldalign = ["left", "center", "center", "center", "right", "right"];
    var table = $('<table>');
    var thead = $('<thead>');

    var tr = $('<tr>');
    var i = 0;

    for (i = 0; i < header.length; i++) {
        var th = $('<th>');
        th.append(header[i]);
        th.css('border-style', "solid");
        th.css('border-width', "2px");
        th.css('padding', "3px");
        tr.append(th);
    }

    thead.append(tr);

    table.append(thead);
    var tbody = $('<tbody>');

    for (i = 0; i < prodarray.length; i++) {

        var tr = $('<tr>');
        for (var j = 0; j < fields.length; j++) {
            var td = $('<td>');
            var val = prodarray[i][fields[j]] ? prodarray[i][fields[j]] : " ";
            /*if (j == 2) {
                if (val == "OUT") {
                    val = "Bezahlen";
                } else if (val == "IN") {
                    val = "Aufladen";
                }
            } else if (j == 4) {
                val = val + " &euro;";
            } else if (j == 0) {
                if (me.shops[val]) {
                    val = me.shops[val];
                }
            }*/
            if (j == fields.length - 1) {
                var input = $('<input id=' + prodarray[i].name.replace(/ /g, '_') + ' name=' + prodarray[i].name.replace(/ /g, '_') + ' style="font-size:2.5vh">');
                //  input.attr('id', prodarray.name);
                //  input.attr('name', prodarray.name);
                input.css({
                    'background-color': 'white',
                    'padding': '10px',
                    'margin': '0px'
                        //								'width': '90%'
                });
                val = input;
                input.click(function() {
                    $(this).focus();
                    if (me.focusedComponent)
                        me.focusedComponent.css('background-color', 'white');
                    $(this).css({
                        'background-color': 'yellow',
                    });
                    me.focusedComponent = $(this);
                });
            }
            td.append(val);
            td.css('border-style', "solid");
            td.css('border-width', "1px");
            td.css('padding', "3px");
            td.css('text-align', fieldalign[j]);
            tr.append(td);
        }
        tbody.append(tr);
    }
    table.append(tbody);

    //  table.css('width', "44vw");
    //  table.css('z-index', "2000");
    table.css('border-style', "solid");
    table.css('border-width', "2px");
    table.css('font-size', '2.5vh');
    table.attr('id', 'orderingtable');

    tablediv.append(table);
    tablediv.css('z-index', "20000");
    tablediv.css('background-color', "white");
    tablediv.css('position', "absolute");
    tablediv.css('height', "99%");
    tablediv.css('width', "60%");
    tablediv.css('overflow-y', "scroll");
    tablediv.css('overflow-x', "none");
    tablediv.css('left', "1%");
    tablediv.css('top', "1%");
    //$('table#orderingtable tr:first input').click();

    //me.focusedComponent = $('table#orderingtable tr:first  input');
    //tablediv.css('webkit-transform':'rotate(180deg)',
    document.styleSheets[0].addRule("::-webkit-scrollbar", "width: 80px;border-style: solid;border-width, 2px;");
    document.styleSheets[0].addRule("::-webkit-scrollbar-thumb", "-webkit-border-radius: 10px;background: rgba(150, 150, 150, 0.8); -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); border-radius: 2;margin: 5px;height: 80px;");

    return tablediv;
}



legacy.productExpiration = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    if (!me.Main.BonManager.currentBonId) {
        var text = POS.lang.getText("MESSAGES", "NO_BON");
        POS.message.show(text, "warning", "");
        return;
    }


    var text = POS.lang.getText("MESSAGES", "CONF_RETURN_PRODUCTS_RECEIPT");
    POS.message.show(text, "question", "YESNO", me, me.doProductExpiration);
}

legacy.doProductExpiration = function(me, result) {

    if (result != "YES")
        return;

    $.when(me.printDeliveryBill("out")).then(function() {
        $.when(me.printDeliveryBill("out")).then(function() {

            me.Main.BonManager.productExpiration();
        });
    });
}

legacy.inventoryList = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.printList(parameters[1]);

    me.removeMe();
}

legacy.stockInput = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    if (!me.Main.BonManager.currentBonId) {
        var text = POS.lang.getText("MESSAGES", "NO_BON");
        POS.message.show(text, "warning", "");
        return;
    }


    var text = POS.lang.getText("MESSAGES", "CONF_IN_STOCK_INPUT");
    POS.message.show(text, "question", "YESNO", me, me.doStockInput);
}

legacy.doStockInput = function(me, result) {

    if (result != "YES")
        return;

    me.Main.BonManager.inStockInput();
}

legacy.stockInfoMode = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);


    var cmp = POS.sessions.getSessionComponent().addChild(CMainPOSInfoMode);
    cmp.mode = "stock";
    cmp.Main = me.Main;
    me.Main.infoCmp = cmp;
    cmp.draw();
}

legacy.printList = function(mode) {
    $.when(this.getProducts(mode)).then(function(parameters) {
        if (!parameters)
            return;

        window.Printer = new CPrinter();

        $.when(Printer.head()).then(function() {
            Printer.addLine("A", 1, false, 0);
            window.text = POS.lang.getText("LABELS", "INVENTORY_LIST");
            Printer.addElement(text, 20, 2, true, 0, 41);

            Printer.addDivisionLine();

            var ColLimits = new Array();
            ColLimits[0] = 34;
            ColLimits[1] = 42;

            Printer.addLine("A", 1, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "PRODUCT"), 0, 0, false, 0,
                ColLimits[0] - 1);
            Printer.addElement(POS.lang.getText("LABELS", "AMOUNT"), ColLimits[1] - 1,
                1, false, ColLimits[0], ColLimits[1] - 1);

            Printer.addLine("B", 1, false, 2);

            for (var i = 0; i < parameters.products.length; i++) {
                Printer.addLine("A", 1, false, 0);
                Printer.addElement(parameters.products[i], 0, 0, false, 0, ColLimits[0] - 1);

                if (mode == "filled")
                    window.text = parameters.stocks[i];
                else if (mode == "empty")
                    window.text = "_____"

                Printer.addElement(text, ColLimits[1] - 1, 1, false, ColLimits[0],
                    ColLimits[1] - 1);
            }

            Printer.addDivisionLine();

            Printer.addLine("B", 1, false, 0);
            window.text = POS.lang.getText("LABELS", "CASHBOX") + " |" +
                POS.lang.getText("LABELS", "RECEIPT_NUMBER") + "| " +
                POS.lang.getText("LABELS", "USER") + " |   " +
                POS.lang.getText("LABELS", "DATE") + "    | " +
                POS.lang.getText("LABELS", "TIME");
            Printer.addElement(text, 4, 0, false, 4, 55);

            Printer.addLine("B", 1, false, 0);
            var now = new Date();
            window.text = expandInteger(POS.POSId, 5) + " | --------- | ";
            window.text += expandInteger(POS.sessions.getSessionComponent().userProps.Login, 8) + " | " +
                expandInteger(now.getDate(), 2) +
                "." + expandInteger(now.getMonth() + 1, 2) +
                "." + now.getFullYear() + " |  " + expandInteger(now.getHours(), 2) +
                ":" + expandInteger(now.getMinutes(), 2);
            Printer.addElement(text, 4, 0, false, 4, 55);

            Printer.print();
        });
    });
}

legacy.getProducts = function(mode) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT Text1, InStock FROM PROD INNER JOIN PRODSTOCK ON " +
        "PROD.PROD_ID = PRODSTOCK.PROD_ID WHERE (InStock > 0 OR InStock < 0) " +
        "AND (Type = 'GEN' OR Type = 'EGN')";
    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        //if (! r.recordCount())
        if (!rows || rows.length < 1) {
            //r.free();
            //return null;
            dfd.resolve(null);
            return;
        }

        var prodArray = new Array();
        var stocksArray = new Array();

        for (var i = 0; i < rows.length; i++) {
            var inStockDB = parseFloat(rows[i].InStock);
            //        if (mode == "filled" && inStockDB <= 0)
            //            continue;

            prodArray[prodArray.length] = rows[i].Text1;
            stocksArray[stocksArray.length] = inStockDB;

            //r.moveNext();
        }

        //r.free();

        var parameters = new Array();
        parameters["products"] = prodArray;
        parameters["stocks"] = stocksArray;

        //return parameters;
        dfd.resolve(parameters);
    });
    return dfd.promise();
}

legacy.printDeliveryBill = function(mode) {
    var defret = jQuery.Deferred();
    var InventoryPanelClass = this;
    if (mode == "out")
        var r = this.getReturnedProducts();
    else if (mode == "in")
        r = this.getReturnStockProducts();

    $.when(r).then(function(parameters) {
        if (!parameters) {
            defret.resolve();
            return;
        }
        window.Printer = new CPrinter();

        $.when(Printer.head()).then(function() {
            Printer.addLine("A", 1, false, 0);
            if (mode == "out")
                var text = POS.lang.getText("LABELS", "RETURN_DELIVERY_BILL");
            else if (mode == "in")
                text = POS.lang.getText("LABELS", "RETURN_STOCK_STATE");

            Printer.addElement(text, 20, 2, true, 0, 41);

            Printer.addDivisionLine();

            var ColLimits = new Array();
            ColLimits[0] = 34;
            ColLimits[1] = 42;

            Printer.addLine("A", 1, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "PRODUCT"), 0, 0, false, 0,
                ColLimits[0] - 1);
            Printer.addElement(POS.lang.getText("LABELS", "AMOUNT"), ColLimits[1] - 1,
                1, false, ColLimits[0], ColLimits[1] - 1);

            Printer.addLine("B", 1, false, 0);

            for (var i = 0; i < parameters.products.length; i++) {
                parameters.quantities[i] = parameters.quantities[i].toString();
                var isGroup = parameters.groupFlags[i];

                var pointsLength = ColLimits[1] - entityToUmlau(parameters.products[i]).length -
                    parameters.quantities[i].length;

                var newLine = parameters.products[i];
                if (!isGroup) {
                    for (var j = 0; j < pointsLength; j++)
                        newLine += ".";
                    newLine += parameters.quantities[i];
                }

                if (isGroup)
                    Printer.addLine("A", 1, false, 2);
                Printer.addLine("A", 1, false, isGroup ? 1 : 0);
                Printer.addElement(newLine, 0, 0, isGroup ? true : false, 0, ColLimits[1] - 1);
                sdump(newLine);
            }

            Printer.addDivisionLine();

            Printer.addLine("A", 2, false, 0);
            Printer.addElement(POS.lang.getText("LABELS", "SUM") + ":", 0, 0, true, 0, 20);
            var sum = float2StringD2(InventoryPanelClass.Main.BonManager.getSumArray()[0]);
            Printer.addElement(sum + " &euro;", 41, 1, true, 0, 41);

            Printer.addDivisionLine();

            Printer.addLine("B", 1, false, 0);
            text = POS.lang.getText("LABELS", "CASHBOX") + " |" +
                POS.lang.getText("LABELS", "RECEIPT_NUMBER") + "| " +
                POS.lang.getText("LABELS", "USER") + " |   " +
                POS.lang.getText("LABELS", "DATE") + "    | " +
                POS.lang.getText("LABELS", "TIME");
            Printer.addElement(text, 4, 0, false, 4, 55);

            Printer.addLine("B", 1, false, 0);
            var now = new Date();
            var bonId = expandInteger(InventoryPanelClass.Main.BonManager.currentBonId, 9);
            text = expandInteger(POS.POSId, 5) + " | " + bonId + " | ";
            text += expandInteger(POS.sessions.getSessionComponent().userProps.Login, 8) + " | " +
                expandInteger(now.getDate(), 2) +
                "." + expandInteger(now.getMonth() + 1, 2) +
                "." + now.getFullYear() + " |  " + expandInteger(now.getHours(), 2) +
                ":" + expandInteger(now.getMinutes(), 2);
            Printer.addElement(text, 4, 0, false, 4, 55);

            Printer.print();
            defret.resolve();
        });
    });
    return defret.promise();
}

legacy.getReturnedProducts = function() {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var bonId = this.Main.BonManager.currentBonId;

    var sql = "SELECT Text1, Text2 FROM BTN WHERE Parent_BTN_ID = 0 ORDER BY BTN_ID";

    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        var prodGroups = new Array();

        for (var i = 0; i < rows.length; i++) {
            var groupName = rows[i].Text1;
            groupName += rows[i].Text2 ? " " + rows[i].Text2 : "";
            prodGroups.push(groupName);
            prodGroups[groupName] = new Array("prodInfos", "total");
            prodGroups[groupName]["prodInfos"] = new Array();
            prodGroups[groupName]["total"] = 0;
            // r.moveNext();
        }
        prodGroups.push("Strichcodes");
        prodGroups["Strichcodes"] = new Array("prodInfos", "total");
        prodGroups["Strichcodes"]["prodInfos"] = new Array();
        prodGroups["Strichcodes"]["total"] = 0;

        sql = "SELECT Qty, Foreign_ID, Text1, Amount_Unit FROM BONE WHERE BON_ID = " + bonId +
            " AND BONE.Type = 'POS' AND BONE.Cancelled = 0";

        $.when(POS.SQLiteCon.execute(sql)).then(function(rows2) {
            //if (! r.recordCount())
            if (rows2.length < 1) {
                //r.free();
                //return null;
                dfd.resolve(null);
                return;
            }
            /*
            for(i = 0; i < rows2.length; i ++){
            var prodId = rows2[i].Foreign_ID;
            var qty = parseFloat(rows2[i].Qty);
            var prodName = lrtrim(rows2[i].Text1);
            var unitAmount = rows2[i].Amount_Unit;

            sql = "SELECT BTN_ID, Text1, Text2, Text3, FreePrice FROM BTN WHERE PROD_ID = " + prodId;

            var r2 = POS.SQLiteCon.execute(sql);
            $.when(r2).then(function(rows3) {
            //if (! r2.recordCount())
            if (rows3.length<1){
            prodGroups["Strichcodes"]["total"] += qty;
            prodGroups["Strichcodes"]["prodInfos"].push(prodName + "#" + qty);
            }
            else{
            var btnId = rows3[0].BTN_ID;
            var text1 = lrtrim(rows3[0].Text1);
            var text2 = lrtrim(rows3[0].Text2);
            var text3 = lrtrim(rows3[0].Text3);
            prodName = text1.replace("-<br>", "");
            prodName += text2 ? " " + text2 : "";
            prodName += text3 ? " " + text3 : "";
            var freePrice = rows3[0].FreePrice;
            sql = "SELECT Text1, Text2 FROM BTN WHERE Parent_BTN_ID = 0 AND BTN_ID < " +
            btnId + " ORDER BY BTN_ID DESC LIMIT 1";
            var r3 = POS.SQLiteCon.execute(sql);
            $.when(r3).then(function(rows4) {
            //if (! r2.recordCount())
            if (rows4.length<1){
            prodGroups["Strichcodes"]["total"] += qty;
            prodGroups["Strichcodes"]["prodInfos"].push(prodName + "#" + qty);
            }
            else{
            groupName = rows4[0].Text1;
            groupName += rows4[0].Text2 ? " " + rows4[0].Text2 : "";
            if (freePrice == "1")
            prodName += " " + float2StringD2(unitAmount)
            prodGroups[groupName]["total"] += qty;
            prodGroups[groupName]["prodInfos"].push(prodName + "#" + qty);
            }
            });
            }
            //r.moveNext();
            });
            }
             */

            var def = $.Deferred();
            var iterator = function it(i) {
                if (i < rows2.length) {

                    var prodId = rows2[i].Foreign_ID;
                    var qty = parseFloat(rows2[i].Qty);
                    var prodName = lrtrim(rows2[i].Text1);
                    var unitAmount = rows2[i].Amount_Unit;

                    sql = "SELECT BTN_ID, Text1, Text2, Text3, FreePrice FROM BTN WHERE PROD_ID = " + prodId;
                    $.when(POS.SQLiteCon.execute(sql)).then(function(rows3) {
                        //if (! r2.recordCount())
                        if (rows3.length < 1) {
                            prodGroups["Strichcodes"]["total"] += qty;
                            prodGroups["Strichcodes"]["prodInfos"].push(prodName + "#" + qty);
                            iterator(i + 1);
                            return;
                        } else {
                            var btnId = rows3[0].BTN_ID;
                            var text1 = lrtrim(rows3[0].Text1);
                            var text2 = lrtrim(rows3[0].Text2);
                            var text3 = lrtrim(rows3[0].Text3);
                            prodName = text1.replace("-<br>", "");
                            prodName += text2 ? " " + text2 : "";
                            prodName += text3 ? " " + text3 : "";
                            var freePrice = rows3[0].FreePrice;
                            sql = "SELECT Text1, Text2 FROM BTN WHERE Parent_BTN_ID = 0 AND BTN_ID < " +
                                btnId + " ORDER BY BTN_ID DESC LIMIT 1";
                            $.when(POS.SQLiteCon.execute(sql)).then(function(rows4) {
                                //if (! r2.recordCount())
                                if (rows4.length < 1) {
                                    prodGroups["Strichcodes"]["total"] += qty;
                                    prodGroups["Strichcodes"]["prodInfos"].push(prodName + "#" + qty);
                                } else {
                                    groupName = rows4[0].Text1;
                                    groupName += rows4[0].Text2 ? " " + rows4[0].Text2 : "";
                                    if (freePrice == "1")
                                        prodName += " " + float2StringD2(unitAmount)
                                    prodGroups[groupName]["total"] += qty;
                                    prodGroups[groupName]["prodInfos"].push(prodName + "#" + qty);
                                }
                                iterator(i + 1);
                                return;
                            });
                        }
                        //r.moveNext();
                    });
                } else {
                    def.resolve();
                    return;
                }
            }
            iterator(0);

            $.when(def).done(function() {
                var prodArray = new Array();
                var qtiesArray = new Array();
                var groupFlags = new Array();

                for (i = 0; i < prodGroups.length; i++) {
                    var group = prodGroups[i];
                    if (prodGroups[group]["total"] > 0) {
                        prodArray[prodArray.length] = group;
                        qtiesArray[qtiesArray.length] = prodGroups[group]["total"];
                        groupFlags[groupFlags.length] = 1;
                        var currGroupIndex = prodArray.length - 1
                        for (var j = 0; j < prodGroups[group]["prodInfos"].length; j++) {
                            var prodInfo = prodGroups[group]["prodInfos"][j];
                            var infoParts = prodInfo.split("#");
                            var found = false;
                            for (var z = currGroupIndex; z < prodArray.length; z++) {
                                if (prodArray[z] == infoParts[0]) {
                                    qtiesArray[z] = parseFloat(qtiesArray[z]) + parseFloat(infoParts[1])
                                    found = true;
                                }
                            }
                            if (!found) {
                                var insertIndex = currGroupIndex + 1;
                                for (var z = insertIndex; z < prodArray.length; z++) {
                                    if (infoParts[0] < prodArray[z]) {
                                        break;
                                    } else {
                                        insertIndex = z + 1;
                                    }
                                }
                                prodArray.splice(insertIndex, 0, infoParts[0]);
                                qtiesArray.splice(insertIndex, 0, infoParts[1]);
                                groupFlags.splice(insertIndex, 0, 0);
                            }
                        }
                    }
                }

                var parameters = new Array();
                parameters["products"] = prodArray;
                parameters["quantities"] = qtiesArray;
                parameters["groupFlags"] = groupFlags;

                /* r.free();
                r2.free();

                return parameters;*/
                dfd.resolve(parameters);
            });
        });
    });
    return dfd.promise();
}

legacy.getReturnStockProducts = function(component, parameters) {
    var dfd = jQuery.Deferred();

    var sql = "SELECT ReturnStock, PROD.Text1 FROM PROD INNER JOIN PRODSTOCK ON " +
        "PROD.PROD_ID = PRODSTOCK.PROD_ID WHERE ReturnStock > 0";

    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        //if (!r.recordCount())
        //return null;
        if (!rows || rows.length < 1) {
            dfd.resolve(null);
            return;
        }
        var remainingProdArray = new Array();
        var remainingQtiesArray = new Array();

        for (var i = 0; i < rows.length; i++) {
            remainingProdArray[remainingProdArray.length] = rows[i].PROD.Text1;
            remainingQtiesArray[remainingQtiesArray.length] = rows[i].ReturnStock;
            //r.moveNext();
        }

        var parameters = new Array();
        parameters["products"] = remainingProdArray;
        parameters["quantities"] = remainingQtiesArray;
        dfd.resolve(parameters);
        //return parameters;
    });
    return dfd.promise();
}


function CInventoryPanelScreen({ bridge }) {
  const t = bridge.t;

  // btns[3] und btns[4] hingen im Legacy an cmpChanges statt am eigenen
  // Screen - Handler UND parameter_0 zeigen dorthin. Das bleibt so, sonst
  // liefe "Produkt umbuchen" gegen den falschen Screen.
  const changes = bridge.Main.cmpChanges;

  const knoepfe = [
    { text: t('BUTTONS', 'PRODUCT_EXPIRATE'), handler: bridge.productExpiration },
    { text: t('BUTTONS', 'IN_STOCK_INPUT'), handler: bridge.stockInput },
    { text: t('BUTTONS', 'IN_STOCK_INFO'), handler: bridge.stockInfoMode },
    { text: t('BUTTONS', 'PRODUCT_CHANGE'), handler: changes.productChange, param0: changes.id },
    { text: t('BUTTONS', 'NEW_PRODUCT_PRICE'), handler: changes.newBunchWithPrice, param0: changes.id, param1: 'NEW_PRICE' },
    { text: t('BUTTONS', 'ORDERING'), handler: bridge.orderings },
  ];

  return <SecondaryPanel bridge={bridge} spalten={6} knoepfe={knoepfe} />;
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CInventoryPanel(id) {
//     this.construct(id, "secondaryPanel CInventoryPanel");
// 
//     this.htmlType = "span";
// 
//     this.properties = {
//         styles: {}
//     }
// 
//     this.Main = null;
// }
export const CInventoryPanel = defineReactScreen({
  className: 'CInventoryPanel',
  addclass: 'secondaryPanel CInventoryPanel',
  htmlType: 'span',
  Screen: CInventoryPanelScreen,
  // Kein prepare/mountLegacy mehr: das Legacy-prepare baute den
  // Widget-Baum aus LYT_secondaryPanel.xml, den rendert jetzt React
  // selbst (SecondaryPanel). Uebrig bleiben die Methoden - die sind
  // WOERTLICH die alten.
  legacyMethods: legacy,
});
